var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendario-(2)-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7266 9.02344C15.7266 8.54882 16.1113 8.16406 16.5859 8.16406C17.0606 8.16406 17.4453 8.54882 17.4453 9.02344C17.4453 9.49806 17.0606 9.88281 16.5859 9.88281C16.1113 9.88281 15.7266 9.49806 15.7266 9.02344Z",
    id: "Circle",
    fill: "#10B48C",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5625 1.71875L17.4453 1.71875L17.4453 0.859375C17.4453 0.384742 17.0606 0 16.5859 0C16.1113 0 15.7266 0.384742 15.7266 0.859375L15.7266 1.71875L11.8164 1.71875L11.8164 0.859375C11.8164 0.384742 11.4317 0 10.957 0C10.4824 0 10.0977 0.384742 10.0977 0.859375L10.0977 1.71875L6.23047 1.71875L6.23047 0.859375C6.23047 0.384742 5.84573 0 5.37109 0C4.89646 0 4.51172 0.384742 4.51172 0.859375L4.51172 1.71875L3.4375 1.71875C1.54206 1.71875 0 3.26081 0 5.15625L0 18.5625C0 20.4579 1.54206 22 3.4375 22L10.0117 22C10.4864 22 10.8711 21.6153 10.8711 21.1406C10.8711 20.666 10.4864 20.2813 10.0117 20.2813L3.4375 20.2813C2.48978 20.2813 1.71875 19.5102 1.71875 18.5625L1.71875 5.15625C1.71875 4.20853 2.48978 3.4375 3.4375 3.4375L4.51172 3.4375L4.51172 4.29688C4.51172 4.77151 4.89646 5.15625 5.37109 5.15625C5.84573 5.15625 6.23047 4.77151 6.23047 4.29688L6.23047 3.4375L10.0977 3.4375L10.0977 4.29688C10.0977 4.77151 10.4824 5.15625 10.957 5.15625C11.4317 5.15625 11.8164 4.77151 11.8164 4.29688L11.8164 3.4375L15.7266 3.4375L15.7266 4.29688C15.7266 4.77151 16.1113 5.15625 16.5859 5.15625C17.0606 5.15625 17.4453 4.77151 17.4453 4.29688L17.4453 3.4375L18.5625 3.4375C19.5102 3.4375 20.2813 4.20853 20.2813 5.15625L20.2813 10.0547C20.2813 10.5293 20.666 10.9141 21.1406 10.9141C21.6153 10.9141 22 10.5293 22 10.0547L22 5.15625C22 3.26081 20.4579 1.71875 18.5625 1.71875L18.5625 1.71875Z",
    id: "Shape",
    fill: "#10B48C",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8008 11.6016C13.9339 11.6016 11.6016 13.9339 11.6016 16.8008C11.6016 19.6677 13.9339 22 16.8008 22C19.6677 22 22 19.6677 22 16.8008C22 13.9339 19.6677 11.6016 16.8008 11.6016L16.8008 11.6016ZM16.8008 20.2813C14.8817 20.2813 13.3203 18.7199 13.3203 16.8008C13.3203 14.8816 14.8817 13.3203 16.8008 13.3203C18.7199 13.3203 20.2813 14.8816 20.2813 16.8008C20.2813 18.7199 18.7199 20.2813 16.8008 20.2813L16.8008 20.2813Z",
    id: "Shape",
    fill: "#10B48C",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0469 15.9414L17.6602 15.9414L17.6602 15.0391C17.6602 14.5644 17.2754 14.1797 16.8008 14.1797C16.3261 14.1797 15.9414 14.5644 15.9414 15.0391L15.9414 16.8008C15.9414 17.2754 16.3261 17.6602 16.8008 17.6602L18.0469 17.6602C18.5215 17.6602 18.9063 17.2754 18.9063 16.8008C18.9063 16.3261 18.5215 15.9414 18.0469 15.9414L18.0469 15.9414Z",
    id: "Shape",
    fill: "#10B48C",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9883 9.02344C11.9883 8.54882 12.373 8.16406 12.8477 8.16406C13.3223 8.16406 13.707 8.54882 13.707 9.02344C13.707 9.49806 13.3223 9.88281 12.8477 9.88281C12.373 9.88281 11.9883 9.49806 11.9883 9.02344Z",
    id: "Circle",
    fill: "#10B48C",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 12.7617C8.25 12.2871 8.63476 11.9023 9.10938 11.9023C9.58399 11.9023 9.96875 12.2871 9.96875 12.7617C9.96875 13.2363 9.58399 13.6211 9.10938 13.6211C8.63476 13.6211 8.25 13.2363 8.25 12.7617Z",
    id: "Circle",
    fill: "#10B48C",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.51172 9.02344C4.51172 8.54882 4.89647 8.16406 5.37109 8.16406C5.84571 8.16406 6.23047 8.54882 6.23047 9.02344C6.23047 9.49806 5.84571 9.88281 5.37109 9.88281C4.89647 9.88281 4.51172 9.49806 4.51172 9.02344Z",
    id: "Circle",
    fill: "#10B48C",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.51172 12.7617C4.51172 12.2871 4.89647 11.9023 5.37109 11.9023C5.84571 11.9023 6.23047 12.2871 6.23047 12.7617C6.23047 13.2363 5.84571 13.6211 5.37109 13.6211C4.89647 13.6211 4.51172 13.2363 4.51172 12.7617Z",
    id: "Circle",
    fill: "#10B48C",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.51172 16.5C4.51172 16.0254 4.89647 15.6406 5.37109 15.6406C5.84571 15.6406 6.23047 16.0254 6.23047 16.5C6.23047 16.9746 5.84571 17.3594 5.37109 17.3594C4.89647 17.3594 4.51172 16.9746 4.51172 16.5Z",
    id: "Circle",
    fill: "#10B48C",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 16.5C8.25 16.0254 8.63476 15.6406 9.10938 15.6406C9.58399 15.6406 9.96875 16.0254 9.96875 16.5C9.96875 16.9746 9.58399 17.3594 9.10938 17.3594C8.63476 17.3594 8.25 16.9746 8.25 16.5Z",
    id: "Circle",
    fill: "#10B48C",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 9.02344C8.25 8.54882 8.63476 8.16406 9.10938 8.16406C9.58399 8.16406 9.96875 8.54882 9.96875 9.02344C9.96875 9.49806 9.58399 9.88281 9.10938 9.88281C8.63476 9.88281 8.25 9.49806 8.25 9.02344Z",
    id: "Circle",
    fill: "#10B48C",
    fillRule: "evenodd",
    stroke: "none"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCalendar);
export default __webpack_public_path__ + "static/media/greenCalendar.5ca8c6cc1337a5a8c557d81b88be630b.svg";
export { ForwardRef as ReactComponent };